/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : PRODUCT TABS : STYLES --------------- ++++++++++ */
export default theme => ({
  producttabs: {
    borderBottom: '2px solid #DFDFDF',
    height: pxToEm(50),
    '& .icons': {
      '& svg': {
        cursor: 'pointer',
      },
      borderRight: '2px solid #DFDFDF',
      '&:last-child': {
        borderRight: '0'
      }
    }
  }
});
